import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#5C2C94",
        secondary: "#F67015",
        accent: "#FFA800",
        error: "#b71c1c",
        tertiary: "#1D60E1",
      },
    },
  },
});
